export const regionToCountry: Record<string, string> = {
  'Africa/Abidjan': "Côte d'Ivoire",
  'Africa/Algiers': 'Algeria',
  'Africa/Bissau': 'Guinea-Bissau',
  'Africa/Cairo': 'Egypt',
  'Africa/Casablanca': 'Morocco',
  'Africa/Ceuta': 'Spain',
  'Africa/Dakar': 'Senegal',
  'Africa/Dar_es_Salaam': 'Tanzania',
  'Africa/El_Aaiun': 'Western Sahara',
  'Africa/Freetown': 'Sierra Leone',
  'Africa/Harare': 'Zimbabwe',
  'Africa/Johannesburg': 'South Africa',
  'Africa/Juba': 'South Sudan',
  'Africa/Kampala': 'Uganda',
  'Africa/Khartoum': 'Sudan',
  'Africa/Kigali': 'Rwanda',
  'Africa/Lagos': 'Nigeria',
  'Africa/Lome': 'Togo',
  'Africa/Lusaka': 'Zambia',
  'Africa/Maputo': 'Mozambique',
  'Africa/Mbabane': 'Eswatini',
  'Africa/Mogadishu': 'Somalia',
  'Africa/Monrovia': 'Liberia',
  'Africa/Nairobi': 'Kenya',
  'Africa/Ndjamena': 'Chad',
  'Africa/Sao_Tome': 'São Tomé & Príncipe',
  'Africa/Tripoli': 'Libya',
  'Africa/Tunis': 'Tunisia',
  'Africa/Windhoek': 'Namibia',
  'America/Adak': 'United States',
  'America/Anchorage': 'United States',
  'America/Araguaina': 'Brazil',
  'America/Argentina/Buenos_Aires': 'Argentina',
  'America/Argentina/Catamarca': 'Argentina',
  'America/Argentina/Cordoba': 'Argentina',
  'America/Argentina/Jujuy': 'Argentina',
  'America/Argentina/La_Rioja': 'Argentina',
  'America/Argentina/Mendoza': 'Argentina',
  'America/Argentina/Rio_Gallegos': 'Argentina',
  'America/Argentina/Salta': 'Argentina',
  'America/Argentina/San_Juan': 'Argentina',
  'America/Argentina/San_Luis': 'Argentina',
  'America/Argentina/Tucuman': 'Argentina',
  'America/Argentina/Ushuaia': 'Argentina',
  'America/Asuncion': 'Paraguay',
  'America/Bahia': 'Brazil',
  'America/Bahia_Banderas': 'Mexico',
  'America/Barbados': 'Barbados',
  'America/Belem': 'Brazil',
  'America/Belize': 'Belize',
  'America/Boa_Vista': 'Brazil',
  'America/Bogota': 'Colombia',
  'America/Boise': 'United States',
  'America/Cambridge_Bay': 'Canada',
  'America/Campo_Grande': 'Brazil',
  'America/Cancun': 'Mexico',
  'America/Caracas': 'Venezuela',
  'America/Cayenne': 'French Guiana',
  'America/Chicago': 'United States',
  'America/Chihuahua': 'Mexico',
  'America/Costa_Rica': 'Costa Rica',
  'America/Cuiaba': 'Brazil',
  'America/Danmarkshavn': 'Greenland',
  'America/Dawson': 'Canada',
  'America/Dawson_Creek': 'Canada',
  'America/Denver': 'United States',
  'America/Detroit': 'United States',
  'America/Edmonton': 'Canada',
  'America/Eirunepe': 'Brazil',
  'America/El_Salvador': 'El Salvador',
  'America/Fortaleza': 'Brazil',
  'America/Fort_Nelson': 'Canada',
  'America/Glace_Bay': 'Canada',
  'America/Goose_Bay': 'Canada',
  'America/Grand_Turk': 'Turks & Caicos Islands',
  'America/Guayaquil': 'Ecuador',
  'America/Guatemala': 'Guatemala',
  'America/Guyana': 'Guyana',
  'America/Halifax': 'Canada',
  'America/Havana': 'Cuba',
  'America/Hermosillo': 'Mexico',
  'America/Indiana/Indianapolis': 'United States',
  'America/Indiana/Knox': 'United States',
  'America/Indiana/Marengo': 'United States',
  'America/Indiana/Petersburg': 'United States',
  'America/Indiana/Tell_City': 'United States',
  'America/Indiana/Vevay': 'United States',
  'America/Indiana/Vincennes': 'United States',
  'America/Indiana/Winamac': 'United States',
  'America/Inuvik': 'Canada',
  'America/Iqaluit': 'Canada',
  'America/Jamaica': 'Jamaica',
  'America/Juneau': 'United States',
  'America/Kentucky/Louisville': 'United States',
  'America/Kentucky/Monticello': 'United States',
  'America/La_Paz': 'Bolivia',
  'America/Lima': 'Peru',
  'America/Los_Angeles': 'United States',
  'America/Lower_Princes': 'Sint Maarten',
  'America/Maceio': 'Brazil',
  'America/Managua': 'Nicaragua',
  'America/Manaus': 'Brazil',
  'America/Martinique': 'Martinique',
  'America/Matamoros': 'Mexico',
  'America/Mazatlan': 'Mexico',
  'America/Menominee': 'United States',
  'America/Merida': 'Mexico',
  'America/Metlakatla': 'United States',
  'America/Mexico_City': 'Mexico',
  'America/Miquelon': 'Saint Pierre and Miquelon',
  'America/Moncton': 'Canada',
  'America/Monterrey': 'Mexico',
  'America/Montevideo': 'Uruguay',
  'America/New_York': 'United States',
  'America/Nipigon': 'Canada',
  'America/Nome': 'United States',
  'America/Noronha': 'Brazil',
  'America/North_Dakota/Beulah': 'United States',
  'America/North_Dakota/Center': 'United States',
  'America/North_Dakota/New_Salem': 'United States',
  'America/Nuuk': 'Greenland',
  'America/Ojinaga': 'Mexico',
  'America/Panama': 'Panama',
  'America/Pangnirtung': 'Canada',
  'America/Paramaribo': 'Suriname',
  'America/Phoenix': 'United States',
  'America/Port-au-Prince': 'Haiti',
  'America/Porto_Velho': 'Brazil',
  'America/Port_of_Spain': 'Trinidad & Tobago',
  'America/Puerto_Rico': 'Puerto Rico',
  'America/Punta_Arenas': 'Chile',
  'America/Rainy_River': 'Canada',
  'America/Rankin_Inlet': 'Canada',
  'America/Recife': 'Brazil',
  'America/Regina': 'Canada',
  'America/Resolute': 'Canada',
  'America/Rio_Branco': 'Brazil',
  'America/Santarem': 'Brazil',
  'America/Santiago': 'Chile',
  'America/Santo_Domingo': 'Dominican Republic',
  'America/Sao_Paulo': 'Brazil',
  'America/Scoresbysund': 'Greenland',
  'America/Sitka': 'United States',
  'America/St_Johns': 'Canada',
  'America/St_Thomas': 'U.S. Virgin Islands',
  'America/St_Vincent': 'Saint Vincent & Grenadines',
  'America/Swift_Current': 'Canada',
  'America/Tegucigalpa': 'Honduras',
  'America/Thunder_Bay': 'Canada',
  'America/Thule': 'Greenland',
  'America/Tijuana': 'Mexico',
  'America/Toronto': 'Canada',
  'America/Tortola': 'British Virgin Islands',
  'America/Vancouver': 'Canada',
  'America/Whitehorse': 'Canada',
  'America/Winnipeg': 'Canada',
  'America/Yakutat': 'United States',
  'America/Yellowknife': 'Canada',
  'Antarctica/Casey': 'Antarctica',
  'Antarctica/Davis': 'Antarctica',
  'Antarctica/Macquarie': 'Australia',
  'Antarctica/Mawson': 'Antarctica',
  'Antarctica/Palmer': 'Antarctica',
  'Antarctica/Rothera': 'Antarctica',
  'Antarctica/Troll': 'Antarctica',
  'Antarctica/Vostok': 'Antarctica',
  'Arctic/Longyearbyen': 'Svalbard & Jan Mayen',
  'Asia/Aden': 'Yemen',
  'Asia/Almaty': 'Kazakhstan',
  'Asia/Amman': 'Jordan',
  'Asia/Anadyr': 'Russia',
  'Asia/Aqtau': 'Kazakhstan',
  'Asia/Aqtobe': 'Kazakhstan',
  'Asia/Ashgabat': 'Turkmenistan',
  'Asia/Atyrau': 'Kazakhstan',
  'Asia/Baghdad': 'Iraq',
  'Asia/Baku': 'Azerbaijan',
  'Asia/Bangkok': 'Thailand',
  'Asia/Barnaul': 'Russia',
  'Asia/Beirut': 'Lebanon',
  'Asia/Bishkek': 'Kyrgyzstan',
  'Asia/Brunei': 'Brunei',
  'Asia/Calcutta': 'India',
  'Asia/Chita': 'Russia',
  'Asia/Choibalsan': 'Mongolia',
  'Asia/Colombo': 'Sri Lanka',
  'Asia/Damascus': 'Syria',
  'Asia/Dhaka': 'Bangladesh',
  'Asia/Dili': 'Timor-Leste',
  'Asia/Dubai': 'United Arab Emirates',
  'Asia/Dushanbe': 'Tajikistan',
  'Asia/Famagusta': 'Cyprus',
  'Asia/Gaza': 'Palestine',
  'Asia/Hebron': 'Palestine',
  'Asia/Ho_Chi_Minh': 'Vietnam',
  'Asia/Hong_Kong': 'Hong Kong',
  'Asia/Hovd': 'Mongolia',
  'Asia/Irkutsk': 'Russia',
  'Asia/Jakarta': 'Indonesia',
  'Asia/Jayapura': 'Indonesia',
  'Asia/Jerusalem': 'Israel',
  'Asia/Kabul': 'Afghanistan',
  'Asia/Kamchatka': 'Russia',
  'Asia/Karachi': 'Pakistan',
  'Asia/Kathmandu': 'Nepal',
  'Asia/Khandyga': 'Russia',
  'Asia/Kolkata': 'India',
  'Asia/Krasnoyarsk': 'Russia',
  'Asia/Kuala_Lumpur': 'Malaysia',
  'Asia/Kuching': 'Malaysia',
  'Asia/Macau': 'Macau',
  'Asia/Magadan': 'Russia',
  'Asia/Makassar': 'Indonesia',
  'Asia/Manila': 'Philippines',
  'Asia/Nicosia': 'Cyprus',
  'Asia/Novokuznetsk': 'Russia',
  'Asia/Novosibirsk': 'Russia',
  'Asia/Omsk': 'Russia',
  'Asia/Oral': 'Kazakhstan',
  'Asia/Pontianak': 'Indonesia',
  'Asia/Pyongyang': 'Korea (North)',
  'Asia/Qatar': 'Qatar',
  'Asia/Qostanay': 'Kazakhstan',
  'Asia/Qyzylorda': 'Kazakhstan',
  'Asia/Riyadh': 'Saudi Arabia',
  'Asia/Sakhalin': 'Russia',
  'Asia/Samarkand': 'Uzbekistan',
  'Asia/Seoul': 'Korea (South)',
  'Asia/Shanghai': 'China',
  'Asia/Singapore': 'Singapore',
  'Asia/Srednekolymsk': 'Russia',
  'Asia/Taipei': 'Taiwan',
  'Asia/Tashkent': 'Uzbekistan',
  'Asia/Tbilisi': 'Georgia',
  'Asia/Tehran': 'Iran',
  'Asia/Thimphu': 'Bhutan',
  'Asia/Tokyo': 'Japan',
  'Asia/Tomsk': 'Russia',
  'Asia/Ulaanbaatar': 'Mongolia',
  'Asia/Urumqi': 'China',
  'Asia/Ust-Nera': 'Russia',
  'Asia/Vladivostok': 'Russia',
  'Asia/Yakutsk': 'Russia',
  'Asia/Yangon': 'Myanmar (Burma)',
  'Asia/Yekaterinburg': 'Russia',
  'Asia/Yerevan': 'Armenia',
  'Atlantic/Azores': 'Portugal',
  'Atlantic/Bermuda': 'Bermuda',
  'Atlantic/Canary': 'Spain',
  'Atlantic/Cape_Verde': 'Cape Verde',
  'Atlantic/Faroe': 'Faroe Islands',
  'Atlantic/Madeira': 'Portugal',
  'Atlantic/Reykjavik': 'Iceland',
  'Atlantic/South_Georgia': 'South Georgia & the South Sandwich Islands',
  'Atlantic/Stanley': 'Falkland Islands',
  'Atlantic/St_Helena': 'Saint Helena',
  'Australia/Adelaide': 'Australia',
  'Australia/Brisbane': 'Australia',
  'Australia/Broken_Hill': 'Australia',
  'Australia/Darwin': 'Australia',
  'Australia/Eucla': 'Australia',
  'Australia/Hobart': 'Australia',
  'Australia/Lindeman': 'Australia',
  'Australia/Lord_Howe': 'Australia',
  'Australia/Melbourne': 'Australia',
  'Australia/Perth': 'Australia',
  'Australia/Sydney': 'Australia',
  'Europe/Amsterdam': 'Netherlands',
  'Europe/Andorra': 'Andorra',
  'Europe/Astrakhan': 'Russia',
  'Europe/Athens': 'Greece',
  'Europe/Belgrade': 'Serbia',
  'Europe/Berlin': 'Germany',
  'Europe/Bratislava': 'Slovakia',
  'Europe/Brussels': 'Belgium',
  'Europe/Bucharest': 'Romania',
  'Europe/Budapest': 'Hungary',
  'Europe/Chisinau': 'Moldova',
  'Europe/Copenhagen': 'Denmark',
  'Europe/Dublin': 'Ireland',
  'Europe/Gibraltar': 'Gibraltar',
  'Europe/Helsinki': 'Finland',
  'Europe/Istanbul': 'Turkey',
  'Europe/Kaliningrad': 'Russia',
  'Europe/Kiev': 'Ukraine',
  'Europe/Kirov': 'Russia',
  'Europe/Lisbon': 'Portugal',
  'Europe/Ljubljana': 'Slovenia',
  'Europe/London': 'Britain (UK)',
  'Europe/Luxembourg': 'Luxembourg',
  'Europe/Madrid': 'Spain',
  'Europe/Malta': 'Malta',
  'Europe/Minsk': 'Belarus',
  'Europe/Monaco': 'Monaco',
  'Europe/Moscow': 'Russia',
  'Europe/Oslo': 'Norway',
  'Europe/Paris': 'France',
  'Europe/Prague': 'Czech Republic',
  'Europe/Riga': 'Latvia',
  'Europe/Rome': 'Italy',
  'Europe/Samara': 'Russia',
  'Europe/San_Marino': 'San Marino',
  'Europe/Saratov': 'Russia',
  'Europe/Simferopol': 'Russia',
  'Europe/Sofia': 'Bulgaria',
  'Europe/Stockholm': 'Sweden',
  'Europe/Tallinn': 'Estonia',
  'Europe/Tirane': 'Albania',
  'Europe/Ulyanovsk': 'Russia',
  'Europe/Uzhgorod': 'Ukraine',
  'Europe/Vatican': 'Vatican City',
  'Europe/Vienna': 'Austria',
  'Europe/Vilnius': 'Lithuania',
  'Europe/Volgograd': 'Russia',
  'Europe/Warsaw': 'Poland',
  'Europe/Zaporozhye': 'Ukraine',
  'Europe/Zurich': 'Switzerland',
  'Indian/Chagos': 'British Indian Ocean Territory',
  'Indian/Christmas': 'Christmas Island',
  'Indian/Cocos': 'Cocos (Keeling) Islands',
  'Indian/Kerguelen': 'French Southern Territories',
  'Indian/Maldives': 'Maldives',
  'Indian/Mauritius': 'Mauritius',
  'Indian/Mayotte': 'Mayotte',
  'Indian/Reunion': 'Réunion',
  'Pacific/Apia': 'Samoa',
  'Pacific/Auckland': 'New Zealand',
  'Pacific/Bougainville': 'Papua New Guinea',
  'Pacific/Chatham': 'New Zealand',
  'Pacific/Chuuk': 'Micronesia',
  'Pacific/Easter': 'Chile',
  'Pacific/Efate': 'Vanuatu',
  'Pacific/Fakaofo': 'Tokelau',
  'Pacific/Fiji': 'Fiji',
  'Pacific/Funafuti': 'Tuvalu',
  'Pacific/Galapagos': 'Ecuador',
  'Pacific/Gambier': 'French Polynesia',
  'Pacific/Guadalcanal': 'Solomon Islands',
  'Pacific/Guam': 'Guam',
  'Pacific/Honolulu': 'United States',
  'Pacific/Johnston': 'United States Minor Outlying Islands',
  'Pacific/Kanton': 'Kiribati',
  'Pacific/Kiritimati': 'Kiribati',
  'Pacific/Kosrae': 'Micronesia',
  'Pacific/Kwajalein': 'Marshall Islands',
  'Pacific/Majuro': 'Marshall Islands',
  'Pacific/Marquesas': 'French Polynesia',
  'Pacific/Midway': 'United States Minor Outlying Islands',
  'Pacific/Nauru': 'Nauru',
  'Pacific/Niue': 'Niue',
  'Pacific/Norfolk': 'Norfolk Island',
  'Pacific/Noumea': 'New Caledonia',
  'Pacific/Pago_Pago': 'Samoa (American)',
  'Pacific/Palau': 'Palau',
  'Pacific/Pitcairn': 'Pitcairn Islands',
  'Pacific/Pohnpei': 'Micronesia',
  'Pacific/Port_Moresby': 'Papua New Guinea',
  'Pacific/Rarotonga': 'Cook Islands',
  'Pacific/Tahiti': 'French Polynesia',
  'Pacific/Tarawa': 'Kiribati',
  'Pacific/Tongatapu': 'Tonga',
  'Pacific/Wake': 'United States Minor Outlying Islands',
  'Pacific/Wallis': 'Wallis & Futuna',
};

// Timezone option interface// Timezone option interface
export interface TimezoneOptionProp {
  label: string;
  value: string;
  offset: string;
  abbreviation: string;
}

// Comprehensive timezone options with UTC offsets and abbreviations
export const timezoneOptionsWithOffsets: TimezoneOptionProp[] = [
  {
    label: 'Coordinated Universal Time (UTC)',
    value: 'UTC',
    offset: 'UTC+00:00',
    abbreviation: 'UTC',
  },
  // Africa
  {
    label: 'Greenwich Mean Time (GMT)',
    value: 'Africa/Abidjan',
    offset: 'UTC+00:00',
    abbreviation: 'GMT',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Africa/Algiers',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Greenwich Mean Time (GMT)',
    value: 'Africa/Bissau',
    offset: 'UTC+00:00',
    abbreviation: 'GMT',
  },
  {
    label: 'Eastern European Time (EET)',
    value: 'Africa/Cairo',
    offset: 'UTC+02:00',
    abbreviation: 'EET',
  },
  {
    label: 'Western European Time (WET)',
    value: 'Africa/Casablanca',
    offset: 'UTC+01:00',
    abbreviation: 'WET',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Africa/Ceuta',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Greenwich Mean Time (GMT)',
    value: 'Africa/Dakar',
    offset: 'UTC+00:00',
    abbreviation: 'GMT',
  },
  {
    label: 'East Africa Time (EAT)',
    value: 'Africa/Dar_es_Salaam',
    offset: 'UTC+03:00',
    abbreviation: 'EAT',
  },
  {
    label: 'Western European Time (WET)',
    value: 'Africa/El_Aaiun',
    offset: 'UTC+01:00',
    abbreviation: 'WET',
  },
  {
    label: 'Greenwich Mean Time (GMT)',
    value: 'Africa/Freetown',
    offset: 'UTC+00:00',
    abbreviation: 'GMT',
  },
  {
    label: 'Central Africa Time (CAT)',
    value: 'Africa/Harare',
    offset: 'UTC+02:00',
    abbreviation: 'CAT',
  },
  {
    label: 'South Africa Standard Time (SAST)',
    value: 'Africa/Johannesburg',
    offset: 'UTC+02:00',
    abbreviation: 'SAST',
  },
  {
    label: 'East Africa Time (EAT)',
    value: 'Africa/Juba',
    offset: 'UTC+03:00',
    abbreviation: 'EAT',
  },
  {
    label: 'East Africa Time (EAT)',
    value: 'Africa/Kampala',
    offset: 'UTC+03:00',
    abbreviation: 'EAT',
  },
  {
    label: 'Central Africa Time (CAT)',
    value: 'Africa/Khartoum',
    offset: 'UTC+02:00',
    abbreviation: 'CAT',
  },
  {
    label: 'Central Africa Time (CAT)',
    value: 'Africa/Kigali',
    offset: 'UTC+02:00',
    abbreviation: 'CAT',
  },
  {
    label: 'West Africa Time (WAT)',
    value: 'Africa/Lagos',
    offset: 'UTC+01:00',
    abbreviation: 'WAT',
  },
  {
    label: 'Greenwich Mean Time (GMT)',
    value: 'Africa/Lome',
    offset: 'UTC+00:00',
    abbreviation: 'GMT',
  },
  {
    label: 'Central Africa Time (CAT)',
    value: 'Africa/Lusaka',
    offset: 'UTC+02:00',
    abbreviation: 'CAT',
  },
  {
    label: 'Central Africa Time (CAT)',
    value: 'Africa/Maputo',
    offset: 'UTC+02:00',
    abbreviation: 'CAT',
  },
  {
    label: 'South Africa Standard Time (SAST)',
    value: 'Africa/Mbabane',
    offset: 'UTC+02:00',
    abbreviation: 'SAST',
  },
  {
    label: 'East Africa Time (EAT)',
    value: 'Africa/Mogadishu',
    offset: 'UTC+03:00',
    abbreviation: 'EAT',
  },
  {
    label: 'Greenwich Mean Time (GMT)',
    value: 'Africa/Monrovia',
    offset: 'UTC+00:00',
    abbreviation: 'GMT',
  },
  {
    label: 'East Africa Time (EAT)',
    value: 'Africa/Nairobi',
    offset: 'UTC+03:00',
    abbreviation: 'EAT',
  },
  {
    label: 'West Africa Time (WAT)',
    value: 'Africa/Ndjamena',
    offset: 'UTC+01:00',
    abbreviation: 'WAT',
  },
  {
    label: 'Greenwich Mean Time (GMT)',
    value: 'Africa/Sao_Tome',
    offset: 'UTC+00:00',
    abbreviation: 'GMT',
  },
  {
    label: 'Eastern European Time (EET)',
    value: 'Africa/Tripoli',
    offset: 'UTC+02:00',
    abbreviation: 'EET',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Africa/Tunis',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Central Africa Time (CAT)',
    value: 'Africa/Windhoek',
    offset: 'UTC+02:00',
    abbreviation: 'CAT',
  },

  // Americas
  {
    label: 'Hawaii-Aleutian Daylight Time (HDT)',
    value: 'America/Adak',
    offset: 'UTC-09:00',
    abbreviation: 'HDT',
  },
  {
    label: 'Alaska Standard Time (AKST)',
    value: 'America/Anchorage',
    offset: 'UTC-09:00',
    abbreviation: 'AKST',
  },
  {
    label: 'Brasilia Time (BRT)',
    value: 'America/Araguaina',
    offset: 'UTC-03:00',
    abbreviation: 'BRT',
  },
  {
    label: 'Argentina Time (ART)',
    value: 'America/Argentina/Buenos_Aires',
    offset: 'UTC-03:00',
    abbreviation: 'ART',
  },
  {
    label: 'Argentina Time (ART)',
    value: 'America/Argentina/Catamarca',
    offset: 'UTC-03:00',
    abbreviation: 'ART',
  },
  {
    label: 'Argentina Time (ART)',
    value: 'America/Argentina/Cordoba',
    offset: 'UTC-03:00',
    abbreviation: 'ART',
  },
  {
    label: 'Argentina Time (ART)',
    value: 'America/Argentina/Jujuy',
    offset: 'UTC-03:00',
    abbreviation: 'ART',
  },
  {
    label: 'Argentina Time (ART)',
    value: 'America/Argentina/La_Rioja',
    offset: 'UTC-03:00',
    abbreviation: 'ART',
  },
  {
    label: 'Argentina Time (ART)',
    value: 'America/Argentina/Mendoza',
    offset: 'UTC-03:00',
    abbreviation: 'ART',
  },
  {
    label: 'Argentina Time (ART)',
    value: 'America/Argentina/Rio_Gallegos',
    offset: 'UTC-03:00',
    abbreviation: 'ART',
  },
  {
    label: 'Argentina Time (ART)',
    value: 'America/Argentina/Salta',
    offset: 'UTC-03:00',
    abbreviation: 'ART',
  },
  {
    label: 'Argentina Time (ART)',
    value: 'America/Argentina/San_Juan',
    offset: 'UTC-03:00',
    abbreviation: 'ART',
  },
  {
    label: 'Argentina Time (ART)',
    value: 'America/Argentina/San_Luis',
    offset: 'UTC-03:00',
    abbreviation: 'ART',
  },
  {
    label: 'Argentina Time (ART)',
    value: 'America/Argentina/Tucuman',
    offset: 'UTC-03:00',
    abbreviation: 'ART',
  },
  {
    label: 'Argentina Time (ART)',
    value: 'America/Argentina/Ushuaia',
    offset: 'UTC-03:00',
    abbreviation: 'ART',
  },
  {
    label: 'Paraguay Time (PYT)',
    value: 'America/Asuncion',
    offset: 'UTC-03:00',
    abbreviation: 'PYT',
  },
  {
    label: 'Brasilia Time (BRT)',
    value: 'America/Bahia',
    offset: 'UTC-03:00',
    abbreviation: 'BRT',
  },
  {
    label: 'Central Standard Time (CST)',
    value: 'America/Bahia_Banderas',
    offset: 'UTC-06:00',
    abbreviation: 'CST',
  },
  {
    label: 'Atlantic Standard Time (AST)',
    value: 'America/Barbados',
    offset: 'UTC-04:00',
    abbreviation: 'AST',
  },
  {
    label: 'Brasilia Time (BRT)',
    value: 'America/Belem',
    offset: 'UTC-03:00',
    abbreviation: 'BRT',
  },
  {
    label: 'Central Standard Time (CST)',
    value: 'America/Belize',
    offset: 'UTC-06:00',
    abbreviation: 'CST',
  },
  {
    label: 'Amazon Time (AMT)',
    value: 'America/Boa_Vista',
    offset: 'UTC-04:00',
    abbreviation: 'AMT',
  },
  {
    label: 'Colombia Time (COT)',
    value: 'America/Bogota',
    offset: 'UTC-05:00',
    abbreviation: 'COT',
  },
  {
    label: 'Mountain Standard Time (MST)',
    value: 'America/Boise',
    offset: 'UTC-07:00',
    abbreviation: 'MST',
  },
  {
    label: 'Mountain Standard Time (MST)',
    value: 'America/Cambridge_Bay',
    offset: 'UTC-07:00',
    abbreviation: 'MST',
  },
  {
    label: 'Amazon Time (AMT)',
    value: 'America/Campo_Grande',
    offset: 'UTC-04:00',
    abbreviation: 'AMT',
  },
  {
    label: 'Eastern Standard Time (EST)',
    value: 'America/Cancun',
    offset: 'UTC-05:00',
    abbreviation: 'EST',
  },
  {
    label: 'Venezuela Time (VET)',
    value: 'America/Caracas',
    offset: 'UTC-04:00',
    abbreviation: 'VET',
  },
  {
    label: 'French Guiana Time (GFT)',
    value: 'America/Cayenne',
    offset: 'UTC-03:00',
    abbreviation: 'GFT',
  },
  {
    label: 'Central Standard Time (CST)',
    value: 'America/Chicago',
    offset: 'UTC-06:00',
    abbreviation: 'CST',
  },
  {
    label: 'Mountain Standard Time (MST)',
    value: 'America/Chihuahua',
    offset: 'UTC-07:00',
    abbreviation: 'MST',
  },
  {
    label: 'Central Standard Time (CST)',
    value: 'America/Costa_Rica',
    offset: 'UTC-06:00',
    abbreviation: 'CST',
  },
  { label: 'Amazon Time (AMT)', value: 'America/Cuiaba', offset: 'UTC-04:00', abbreviation: 'AMT' },
  {
    label: 'Greenwich Mean Time (GMT)',
    value: 'America/Danmarkshavn',
    offset: 'UTC+00:00',
    abbreviation: 'GMT',
  },
  {
    label: 'Pacific Standard Time (PST)',
    value: 'America/Dawson',
    offset: 'UTC-08:00',
    abbreviation: 'PST',
  },
  {
    label: 'Mountain Standard Time (MST)',
    value: 'America/Dawson_Creek',
    offset: 'UTC-07:00',
    abbreviation: 'MST',
  },
  {
    label: 'Mountain Standard Time (MST)',
    value: 'America/Denver',
    offset: 'UTC-07:00',
    abbreviation: 'MST',
  },
  {
    label: 'Eastern Standard Time (EST)',
    value: 'America/Detroit',
    offset: 'UTC-05:00',
    abbreviation: 'EST',
  },
  {
    label: 'Mountain Standard Time (MST)',
    value: 'America/Edmonton',
    offset: 'UTC-07:00',
    abbreviation: 'MST',
  },
  { label: 'Acre Time (ACT)', value: 'America/Eirunepe', offset: 'UTC-05:00', abbreviation: 'ACT' },
  {
    label: 'Central Standard Time (CST)',
    value: 'America/El_Salvador',
    offset: 'UTC-06:00',
    abbreviation: 'CST',
  },
  {
    label: 'Brasilia Time (BRT)',
    value: 'America/Fortaleza',
    offset: 'UTC-03:00',
    abbreviation: 'BRT',
  },
  {
    label: 'Mountain Standard Time (MST)',
    value: 'America/Fort_Nelson',
    offset: 'UTC-07:00',
    abbreviation: 'MST',
  },
  {
    label: 'Atlantic Standard Time (AST)',
    value: 'America/Glace_Bay',
    offset: 'UTC-04:00',
    abbreviation: 'AST',
  },
  {
    label: 'Atlantic Standard Time (AST)',
    value: 'America/Goose_Bay',
    offset: 'UTC-04:00',
    abbreviation: 'AST',
  },
  {
    label: 'Eastern Standard Time (EST)',
    value: 'America/Grand_Turk',
    offset: 'UTC-05:00',
    abbreviation: 'EST',
  },
  {
    label: 'Ecuador Time (ECT)',
    value: 'America/Guayaquil',
    offset: 'UTC-05:00',
    abbreviation: 'ECT',
  },
  {
    label: 'Central Standard Time (CST)',
    value: 'America/Guatemala',
    offset: 'UTC-06:00',
    abbreviation: 'CST',
  },
  { label: 'Guyana Time (GYT)', value: 'America/Guyana', offset: 'UTC-04:00', abbreviation: 'GYT' },
  {
    label: 'Atlantic Standard Time (AST)',
    value: 'America/Halifax',
    offset: 'UTC-04:00',
    abbreviation: 'AST',
  },
  {
    label: 'Cuba Standard Time (CST)',
    value: 'America/Havana',
    offset: 'UTC-05:00',
    abbreviation: 'CST',
  },
  {
    label: 'Mountain Standard Time (MST)',
    value: 'America/Hermosillo',
    offset: 'UTC-07:00',
    abbreviation: 'MST',
  },
  {
    label: 'Eastern Standard Time (EST)',
    value: 'America/Indiana/Indianapolis',
    offset: 'UTC-05:00',
    abbreviation: 'EST',
  },
  {
    label: 'Central Standard Time (CST)',
    value: 'America/Indiana/Knox',
    offset: 'UTC-06:00',
    abbreviation: 'CST',
  },
  {
    label: 'Eastern Standard Time (EST)',
    value: 'America/Indiana/Marengo',
    offset: 'UTC-05:00',
    abbreviation: 'EST',
  },
  {
    label: 'Eastern Standard Time (EST)',
    value: 'America/Indiana/Petersburg',
    offset: 'UTC-05:00',
    abbreviation: 'EST',
  },
  {
    label: 'Central Standard Time (CST)',
    value: 'America/Indiana/Tell_City',
    offset: 'UTC-06:00',
    abbreviation: 'CST',
  },
  {
    label: 'Eastern Standard Time (EST)',
    value: 'America/Indiana/Vevay',
    offset: 'UTC-05:00',
    abbreviation: 'EST',
  },
  {
    label: 'Eastern Standard Time (EST)',
    value: 'America/Indiana/Vincennes',
    offset: 'UTC-05:00',
    abbreviation: 'EST',
  },
  {
    label: 'Eastern Standard Time (EST)',
    value: 'America/Indiana/Winamac',
    offset: 'UTC-05:00',
    abbreviation: 'EST',
  },
  {
    label: 'Mountain Standard Time (MST)',
    value: 'America/Inuvik',
    offset: 'UTC-07:00',
    abbreviation: 'MST',
  },
  {
    label: 'Eastern Standard Time (EST)',
    value: 'America/Iqaluit',
    offset: 'UTC-05:00',
    abbreviation: 'EST',
  },
  {
    label: 'Eastern Standard Time (EST)',
    value: 'America/Jamaica',
    offset: 'UTC-05:00',
    abbreviation: 'EST',
  },
  {
    label: 'Alaska Standard Time (AKST)',
    value: 'America/Juneau',
    offset: 'UTC-09:00',
    abbreviation: 'AKST',
  },
  {
    label: 'Eastern Standard Time (EST)',
    value: 'America/Kentucky/Louisville',
    offset: 'UTC-05:00',
    abbreviation: 'EST',
  },
  {
    label: 'Central Standard Time (CST)',
    value: 'America/Kentucky/Monticello',
    offset: 'UTC-06:00',
    abbreviation: 'CST',
  },
  {
    label: 'Bolivia Time (BOT)',
    value: 'America/La_Paz',
    offset: 'UTC-04:00',
    abbreviation: 'BOT',
  },
  { label: 'Peru Time (PET)', value: 'America/Lima', offset: 'UTC-05:00', abbreviation: 'PET' },
  {
    label: 'Pacific Standard Time (PST)',
    value: 'America/Los_Angeles',
    offset: 'UTC-08:00',
    abbreviation: 'PST',
  },
  {
    label: 'Atlantic Standard Time (AST)',
    value: 'America/Lower_Princes',
    offset: 'UTC-04:00',
    abbreviation: 'AST',
  },
  {
    label: 'Brasilia Time (BRT)',
    value: 'America/Maceio',
    offset: 'UTC-03:00',
    abbreviation: 'BRT',
  },
  {
    label: 'Central Standard Time (CST)',
    value: 'America/Managua',
    offset: 'UTC-06:00',
    abbreviation: 'CST',
  },
  { label: 'Amazon Time (AMT)', value: 'America/Manaus', offset: 'UTC-04:00', abbreviation: 'AMT' },
  {
    label: 'Atlantic Standard Time (AST)',
    value: 'America/Martinique',
    offset: 'UTC-04:00',
    abbreviation: 'AST',
  },
  {
    label: 'Central Standard Time (CST)',
    value: 'America/Matamoros',
    offset: 'UTC-06:00',
    abbreviation: 'CST',
  },
  {
    label: 'Mountain Standard Time (MST)',
    value: 'America/Mazatlan',
    offset: 'UTC-07:00',
    abbreviation: 'MST',
  },
  {
    label: 'Central Standard Time (CST)',
    value: 'America/Menominee',
    offset: 'UTC-06:00',
    abbreviation: 'CST',
  },
  {
    label: 'Central Standard Time (CST)',
    value: 'America/Merida',
    offset: 'UTC-06:00',
    abbreviation: 'CST',
  },
  {
    label: 'Alaska Standard Time (AKST)',
    value: 'America/Metlakatla',
    offset: 'UTC-09:00',
    abbreviation: 'AKST',
  },
  {
    label: 'Central Standard Time (CST)',
    value: 'America/Mexico_City',
    offset: 'UTC-06:00',
    abbreviation: 'CST',
  },
  {
    label: 'Saint Pierre and Miquelon Time (PMST)',
    value: 'America/Miquelon',
    offset: 'UTC-03:00',
    abbreviation: 'PMST',
  },
  {
    label: 'Atlantic Standard Time (AST)',
    value: 'America/Moncton',
    offset: 'UTC-04:00',
    abbreviation: 'AST',
  },
  {
    label: 'Central Standard Time (CST)',
    value: 'America/Monterrey',
    offset: 'UTC-06:00',
    abbreviation: 'CST',
  },
  {
    label: 'Uruguay Time (UYT)',
    value: 'America/Montevideo',
    offset: 'UTC-03:00',
    abbreviation: 'UYT',
  },
  {
    label: 'Eastern Standard Time (EST)',
    value: 'America/New_York',
    offset: 'UTC-05:00',
    abbreviation: 'EST',
  },
  {
    label: 'Eastern Daylight Time (EDT)',
    value: 'America/New_York',
    offset: 'UTC-04:00',
    abbreviation: 'EDT',
  },
  {
    label: 'Eastern Standard Time (EST)',
    value: 'America/Nipigon',
    offset: 'UTC-05:00',
    abbreviation: 'EST',
  },
  {
    label: 'Alaska Standard Time (AKST)',
    value: 'America/Nome',
    offset: 'UTC-09:00',
    abbreviation: 'AKST',
  },
  {
    label: 'Fernando de Noronha Time (FNT)',
    value: 'America/Noronha',
    offset: 'UTC-02:00',
    abbreviation: 'FNT',
  },
  {
    label: 'Central Standard Time (CST)',
    value: 'America/North_Dakota/Beulah',
    offset: 'UTC-06:00',
    abbreviation: 'CST',
  },
  {
    label: 'Central Standard Time (CST)',
    value: 'America/North_Dakota/Center',
    offset: 'UTC-06:00',
    abbreviation: 'CST',
  },
  {
    label: 'Central Standard Time (CST)',
    value: 'America/North_Dakota/New_Salem',
    offset: 'UTC-06:00',
    abbreviation: 'CST',
  },
  {
    label: 'West Greenland Time (WGT)',
    value: 'America/Nuuk',
    offset: 'UTC-03:00',
    abbreviation: 'WGT',
  },
  {
    label: 'Mountain Standard Time (MST)',
    value: 'America/Ojinaga',
    offset: 'UTC-07:00',
    abbreviation: 'MST',
  },
  {
    label: 'Eastern Standard Time (EST)',
    value: 'America/Panama',
    offset: 'UTC-05:00',
    abbreviation: 'EST',
  },
  {
    label: 'Eastern Standard Time (EST)',
    value: 'America/Pangnirtung',
    offset: 'UTC-05:00',
    abbreviation: 'EST',
  },
  {
    label: 'Suriname Time (SRT)',
    value: 'America/Paramaribo',
    offset: 'UTC-03:00',
    abbreviation: 'SRT',
  },
  {
    label: 'Mountain Standard Time (MST)',
    value: 'America/Phoenix',
    offset: 'UTC-07:00',
    abbreviation: 'MST',
  },
  {
    label: 'Eastern Standard Time (EST)',
    value: 'America/Port-au-Prince',
    offset: 'UTC-05:00',
    abbreviation: 'EST',
  },
  {
    label: 'Amazon Time (AMT)',
    value: 'America/Porto_Velho',
    offset: 'UTC-04:00',
    abbreviation: 'AMT',
  },
  {
    label: 'Atlantic Standard Time (AST)',
    value: 'America/Port_of_Spain',
    offset: 'UTC-04:00',
    abbreviation: 'AST',
  },
  {
    label: 'Atlantic Standard Time (AST)',
    value: 'America/Puerto_Rico',
    offset: 'UTC-04:00',
    abbreviation: 'AST',
  },
  {
    label: 'Chile Time (CLT)',
    value: 'America/Punta_Arenas',
    offset: 'UTC-03:00',
    abbreviation: 'CLT',
  },
  {
    label: 'Central Standard Time (CST)',
    value: 'America/Rainy_River',
    offset: 'UTC-06:00',
    abbreviation: 'CST',
  },
  {
    label: 'Central Standard Time (CST)',
    value: 'America/Rankin_Inlet',
    offset: 'UTC-06:00',
    abbreviation: 'CST',
  },
  {
    label: 'Brasilia Time (BRT)',
    value: 'America/Recife',
    offset: 'UTC-03:00',
    abbreviation: 'BRT',
  },
  {
    label: 'Central Standard Time (CST)',
    value: 'America/Regina',
    offset: 'UTC-06:00',
    abbreviation: 'CST',
  },
  {
    label: 'Central Standard Time (CST)',
    value: 'America/Resolute',
    offset: 'UTC-06:00',
    abbreviation: 'CST',
  },
  {
    label: 'Acre Time (ACT)',
    value: 'America/Rio_Branco',
    offset: 'UTC-05:00',
    abbreviation: 'ACT',
  },
  {
    label: 'Brasilia Time (BRT)',
    value: 'America/Santarem',
    offset: 'UTC-03:00',
    abbreviation: 'BRT',
  },
  {
    label: 'Chile Time (CLT)',
    value: 'America/Santiago',
    offset: 'UTC-04:00',
    abbreviation: 'CLT',
  },
  {
    label: 'Atlantic Standard Time (AST)',
    value: 'America/Santo_Domingo',
    offset: 'UTC-04:00',
    abbreviation: 'AST',
  },
  {
    label: 'Brasilia Time (BRT)',
    value: 'America/Sao_Paulo',
    offset: 'UTC-03:00',
    abbreviation: 'BRT',
  },
  {
    label: 'East Greenland Time (EGT)',
    value: 'America/Scoresbysund',
    offset: 'UTC-01:00',
    abbreviation: 'EGT',
  },
  {
    label: 'Alaska Standard Time (AKST)',
    value: 'America/Sitka',
    offset: 'UTC-09:00',
    abbreviation: 'AKST',
  },
  {
    label: 'Newfoundland Standard Time (NST)',
    value: 'America/St_Johns',
    offset: 'UTC-03:30',
    abbreviation: 'NST',
  },
  {
    label: 'Atlantic Standard Time (AST)',
    value: 'America/St_Thomas',
    offset: 'UTC-04:00',
    abbreviation: 'AST',
  },
  {
    label: 'Atlantic Standard Time (AST)',
    value: 'America/St_Vincent',
    offset: 'UTC-04:00',
    abbreviation: 'AST',
  },
  {
    label: 'Central Standard Time (CST)',
    value: 'America/Swift_Current',
    offset: 'UTC-06:00',
    abbreviation: 'CST',
  },
  {
    label: 'Central Standard Time (CST)',
    value: 'America/Tegucigalpa',
    offset: 'UTC-06:00',
    abbreviation: 'CST',
  },
  {
    label: 'Eastern Standard Time (EST)',
    value: 'America/Thunder_Bay',
    offset: 'UTC-05:00',
    abbreviation: 'EST',
  },
  {
    label: 'Atlantic Standard Time (AST)',
    value: 'America/Thule',
    offset: 'UTC-04:00',
    abbreviation: 'AST',
  },
  {
    label: 'Pacific Standard Time (PST)',
    value: 'America/Tijuana',
    offset: 'UTC-08:00',
    abbreviation: 'PST',
  },
  {
    label: 'Eastern Standard Time (EST)',
    value: 'America/Toronto',
    offset: 'UTC-05:00',
    abbreviation: 'EST',
  },
  {
    label: 'Atlantic Standard Time (AST)',
    value: 'America/Tortola',
    offset: 'UTC-04:00',
    abbreviation: 'AST',
  },
  {
    label: 'Pacific Standard Time (PST)',
    value: 'America/Vancouver',
    offset: 'UTC-08:00',
    abbreviation: 'PST',
  },
  {
    label: 'Pacific Standard Time (PST)',
    value: 'America/Whitehorse',
    offset: 'UTC-08:00',
    abbreviation: 'PST',
  },
  {
    label: 'Central Standard Time (CST)',
    value: 'America/Winnipeg',
    offset: 'UTC-06:00',
    abbreviation: 'CST',
  },
  {
    label: 'Alaska Standard Time (AKST)',
    value: 'America/Yakutat',
    offset: 'UTC-09:00',
    abbreviation: 'AKST',
  },
  {
    label: 'Mountain Standard Time (MST)',
    value: 'America/Yellowknife',
    offset: 'UTC-07:00',
    abbreviation: 'MST',
  },

  // Antarctica
  {
    label: 'Australian Western Standard Time (AWST)',
    value: 'Antarctica/Casey',
    offset: 'UTC+08:00',
    abbreviation: 'AWST',
  },
  {
    label: 'Davis Time (DAVT)',
    value: 'Antarctica/Davis',
    offset: 'UTC+07:00',
    abbreviation: 'DAVT',
  },
  {
    label: 'Macquarie Island Time (MIST)',
    value: 'Antarctica/Macquarie',
    offset: 'UTC+11:00',
    abbreviation: 'MIST',
  },
  {
    label: 'Mawson Time (MAWT)',
    value: 'Antarctica/Mawson',
    offset: 'UTC+05:00',
    abbreviation: 'MAWT',
  },
  {
    label: 'Chile Time (CLT)',
    value: 'Antarctica/Palmer',
    offset: 'UTC-03:00',
    abbreviation: 'CLT',
  },
  {
    label: 'Rothera Time (ROTT)',
    value: 'Antarctica/Rothera',
    offset: 'UTC-03:00',
    abbreviation: 'ROTT',
  },
  {
    label: 'Coordinated Universal Time (UTC)',
    value: 'Antarctica/Troll',
    offset: 'UTC+00:00',
    abbreviation: 'UTC',
  },
  {
    label: 'Vostok Time (VOST)',
    value: 'Antarctica/Vostok',
    offset: 'UTC+06:00',
    abbreviation: 'VOST',
  },

  // Arctic
  {
    label: 'Central European Time (CET)',
    value: 'Arctic/Longyearbyen',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },

  // Asia
  {
    label: 'Arabia Standard Time (AST)',
    value: 'Asia/Aden',
    offset: 'UTC+03:00',
    abbreviation: 'AST',
  },
  { label: 'Almaty Time (ALMT)', value: 'Asia/Almaty', offset: 'UTC+06:00', abbreviation: 'ALMT' },
  {
    label: 'Eastern European Time (EET)',
    value: 'Asia/Amman',
    offset: 'UTC+02:00',
    abbreviation: 'EET',
  },
  { label: 'Anadyr Time (ANAT)', value: 'Asia/Anadyr', offset: 'UTC+12:00', abbreviation: 'ANAT' },
  { label: 'Aqtau Time (AQTT)', value: 'Asia/Aqtau', offset: 'UTC+05:00', abbreviation: 'AQTT' },
  { label: 'Aqtobe Time (AQTT)', value: 'Asia/Aqtobe', offset: 'UTC+05:00', abbreviation: 'AQTT' },
  {
    label: 'Turkmenistan Time (TMT)',
    value: 'Asia/Ashgabat',
    offset: 'UTC+05:00',
    abbreviation: 'TMT',
  },
  { label: 'Atyrau Time (AQTT)', value: 'Asia/Atyrau', offset: 'UTC+05:00', abbreviation: 'AQTT' },
  {
    label: 'Arabia Standard Time (AST)',
    value: 'Asia/Baghdad',
    offset: 'UTC+03:00',
    abbreviation: 'AST',
  },
  { label: 'Azerbaijan Time (AZT)', value: 'Asia/Baku', offset: 'UTC+04:00', abbreviation: 'AZT' },
  {
    label: 'Indochina Time (ICT)',
    value: 'Asia/Bangkok',
    offset: 'UTC+07:00',
    abbreviation: 'ICT',
  },
  {
    label: 'Barnaul Time (BART)',
    value: 'Asia/Barnaul',
    offset: 'UTC+07:00',
    abbreviation: 'BART',
  },
  {
    label: 'Eastern European Time (EET)',
    value: 'Asia/Beirut',
    offset: 'UTC+02:00',
    abbreviation: 'EET',
  },
  {
    label: 'Kyrgyzstan Time (KGT)',
    value: 'Asia/Bishkek',
    offset: 'UTC+06:00',
    abbreviation: 'KGT',
  },
  {
    label: 'Brunei Time (BNT)',
    value: 'Asia/Brunei',
    offset: 'UTC+08:00',
    abbreviation: 'BNT',
  },
  {
    label: 'India Standard Time (IST)',
    value: 'Asia/Calcutta',
    offset: 'UTC+05:30',
    abbreviation: 'IST',
  },
  {
    label: 'Yakutsk Time (YAKT)',
    value: 'Asia/Chita',
    offset: 'UTC+09:00',
    abbreviation: 'YAKT',
  },
  {
    label: 'Choibalsan Time (CHOT)',
    value: 'Asia/Choibalsan',
    offset: 'UTC+08:00',
    abbreviation: 'CHOT',
  },
  {
    label: 'India Standard Time (IST)',
    value: 'Asia/Colombo',
    offset: 'UTC+05:30',
    abbreviation: 'IST',
  },
  {
    label: 'Eastern European Time (EET)',
    value: 'Asia/Damascus',
    offset: 'UTC+02:00',
    abbreviation: 'EET',
  },
  {
    label: 'Bangladesh Standard Time (BST)',
    value: 'Asia/Dhaka',
    offset: 'UTC+06:00',
    abbreviation: 'BST',
  },
  {
    label: 'Timor-Leste Time (TLT)',
    value: 'Asia/Dili',
    offset: 'UTC+09:00',
    abbreviation: 'TLT',
  },
  {
    label: 'Gulf Standard Time (GST)',
    value: 'Asia/Dubai',
    offset: 'UTC+04:00',
    abbreviation: 'GST',
  },
  {
    label: 'Tajikistan Time (TJT)',
    value: 'Asia/Dushanbe',
    offset: 'UTC+05:00',
    abbreviation: 'TJT',
  },
  {
    label: 'Eastern European Time (EET)',
    value: 'Asia/Famagusta',
    offset: 'UTC+02:00',
    abbreviation: 'EET',
  },
  {
    label: 'Eastern European Time (EET)',
    value: 'Asia/Gaza',
    offset: 'UTC+02:00',
    abbreviation: 'EET',
  },
  {
    label: 'Eastern European Time (EET)',
    value: 'Asia/Hebron',
    offset: 'UTC+02:00',
    abbreviation: 'EET',
  },
  {
    label: 'Indochina Time (ICT)',
    value: 'Asia/Ho_Chi_Minh',
    offset: 'UTC+07:00',
    abbreviation: 'ICT',
  },
  {
    label: 'Hong Kong Time (HKT)',
    value: 'Asia/Hong_Kong',
    offset: 'UTC+08:00',
    abbreviation: 'HKT',
  },
  {
    label: 'Hovd Time (HOVT)',
    value: 'Asia/Hovd',
    offset: 'UTC+07:00',
    abbreviation: 'HOVT',
  },
  {
    label: 'Irkutsk Time (IRKT)',
    value: 'Asia/Irkutsk',
    offset: 'UTC+08:00',
    abbreviation: 'IRKT',
  },
  {
    label: 'Western Indonesian Time (WIB)',
    value: 'Asia/Jakarta',
    offset: 'UTC+07:00',
    abbreviation: 'WIB',
  },
  {
    label: 'Eastern Indonesian Time (WIT)',
    value: 'Asia/Jayapura',
    offset: 'UTC+09:00',
    abbreviation: 'WIT',
  },
  {
    label: 'Israel Standard Time (IST)',
    value: 'Asia/Jerusalem',
    offset: 'UTC+02:00',
    abbreviation: 'IST',
  },
  {
    label: 'Afghanistan Time (AFT)',
    value: 'Asia/Kabul',
    offset: 'UTC+04:30',
    abbreviation: 'AFT',
  },
  {
    label: 'Petropavlovsk-Kamchatski Time (PETT)',
    value: 'Asia/Kamchatka',
    offset: 'UTC+12:00',
    abbreviation: 'PETT',
  },
  {
    label: 'Pakistan Standard Time (PKT)',
    value: 'Asia/Karachi',
    offset: 'UTC+05:00',
    abbreviation: 'PKT',
  },
  {
    label: 'Nepal Time (NPT)',
    value: 'Asia/Kathmandu',
    offset: 'UTC+05:45',
    abbreviation: 'NPT',
  },
  {
    label: 'Vladivostok Time (VLAT)',
    value: 'Asia/Khandyga',
    offset: 'UTC+10:00',
    abbreviation: 'VLAT',
  },
  {
    label: 'India Standard Time (IST)',
    value: 'Asia/Kolkata',
    offset: 'UTC+05:30',
    abbreviation: 'IST',
  },
  {
    label: 'Krasnoyarsk Time (KRAT)',
    value: 'Asia/Krasnoyarsk',
    offset: 'UTC+07:00',
    abbreviation: 'KRAT',
  },
  {
    label: 'Malaysia Time (MYT)',
    value: 'Asia/Kuala_Lumpur',
    offset: 'UTC+08:00',
    abbreviation: 'MYT',
  },
  {
    label: 'Malaysia Time (MYT)',
    value: 'Asia/Kuching',
    offset: 'UTC+08:00',
    abbreviation: 'MYT',
  },
  {
    label: 'China Standard Time (CST)',
    value: 'Asia/Macau',
    offset: 'UTC+08:00',
    abbreviation: 'CST',
  },
  {
    label: 'Magadan Time (MAGT)',
    value: 'Asia/Magadan',
    offset: 'UTC+11:00',
    abbreviation: 'MAGT',
  },
  {
    label: 'Central Indonesian Time (WITA)',
    value: 'Asia/Makassar',
    offset: 'UTC+08:00',
    abbreviation: 'WITA',
  },
  {
    label: 'Philippine Time (PHT)',
    value: 'Asia/Manila',
    offset: 'UTC+08:00',
    abbreviation: 'PHT',
  },
  {
    label: 'Eastern European Time (EET)',
    value: 'Asia/Nicosia',
    offset: 'UTC+02:00',
    abbreviation: 'EET',
  },
  {
    label: 'Krasnoyarsk Time (KRAT)',
    value: 'Asia/Novokuznetsk',
    offset: 'UTC+07:00',
    abbreviation: 'KRAT',
  },
  {
    label: 'Novosibirsk Time (NOVT)',
    value: 'Asia/Novosibirsk',
    offset: 'UTC+07:00',
    abbreviation: 'NOVT',
  },
  {
    label: 'Omsk Time (OMST)',
    value: 'Asia/Omsk',
    offset: 'UTC+06:00',
    abbreviation: 'OMST',
  },
  {
    label: 'Oral Time (ORAT)',
    value: 'Asia/Oral',
    offset: 'UTC+05:00',
    abbreviation: 'ORAT',
  },
  {
    label: 'Western Indonesian Time (WIB)',
    value: 'Asia/Pontianak',
    offset: 'UTC+07:00',
    abbreviation: 'WIB',
  },
  {
    label: 'Pyongyang Time (PYT)',
    value: 'Asia/Pyongyang',
    offset: 'UTC+09:00',
    abbreviation: 'PYT',
  },
  {
    label: 'Arabia Standard Time (AST)',
    value: 'Asia/Qatar',
    offset: 'UTC+03:00',
    abbreviation: 'AST',
  },
  {
    label: 'Qostanay Time (QYZT)',
    value: 'Asia/Qostanay',
    offset: 'UTC+06:00',
    abbreviation: 'QYZT',
  },
  {
    label: 'Qyzylorda Time (QYZT)',
    value: 'Asia/Qyzylorda',
    offset: 'UTC+05:00',
    abbreviation: 'QYZT',
  },
  {
    label: 'Arabia Standard Time (AST)',
    value: 'Asia/Riyadh',
    offset: 'UTC+03:00',
    abbreviation: 'AST',
  },
  {
    label: 'Sakhalin Time (SAKT)',
    value: 'Asia/Sakhalin',
    offset: 'UTC+11:00',
    abbreviation: 'SAKT',
  },
  {
    label: 'Uzbekistan Time (UZT)',
    value: 'Asia/Samarkand',
    offset: 'UTC+05:00',
    abbreviation: 'UZT',
  },
  {
    label: 'Korea Standard Time (KST)',
    value: 'Asia/Seoul',
    offset: 'UTC+09:00',
    abbreviation: 'KST',
  },
  {
    label: 'China Standard Time (CST)',
    value: 'Asia/Shanghai',
    offset: 'UTC+08:00',
    abbreviation: 'CST',
  },
  {
    label: 'Singapore Time (SGT)',
    value: 'Asia/Singapore',
    offset: 'UTC+08:00',
    abbreviation: 'SGT',
  },
  {
    label: 'Srednekolymsk Time (SRET)',
    value: 'Asia/Srednekolymsk',
    offset: 'UTC+11:00',
    abbreviation: 'SRET',
  },
  {
    label: 'Taipei Time (CST)',
    value: 'Asia/Taipei',
    offset: 'UTC+08:00',
    abbreviation: 'CST',
  },
  {
    label: 'Uzbekistan Time (UZT)',
    value: 'Asia/Tashkent',
    offset: 'UTC+05:00',
    abbreviation: 'UZT',
  },
  {
    label: 'Georgia Time (GET)',
    value: 'Asia/Tbilisi',
    offset: 'UTC+04:00',
    abbreviation: 'GET',
  },
  {
    label: 'Iran Standard Time (IRST)',
    value: 'Asia/Tehran',
    offset: 'UTC+03:30',
    abbreviation: 'IRST',
  },
  {
    label: 'Bhutan Time (BTT)',
    value: 'Asia/Thimphu',
    offset: 'UTC+06:00',
    abbreviation: 'BTT',
  },
  {
    label: 'Japan Standard Time (JST)',
    value: 'Asia/Tokyo',
    offset: 'UTC+09:00',
    abbreviation: 'JST',
  },
  {
    label: 'Tomsk Time (TOMST)',
    value: 'Asia/Tomsk',
    offset: 'UTC+07:00',
    abbreviation: 'TOMST',
  },
  {
    label: 'Ulaanbaatar Time (ULAT)',
    value: 'Asia/Ulaanbaatar',
    offset: 'UTC+08:00',
    abbreviation: 'ULAT',
  },
  {
    label: 'China Standard Time (CST)',
    value: 'Asia/Urumqi',
    offset: 'UTC+08:00',
    abbreviation: 'CST',
  },
  {
    label: 'Vladivostok Time (VLAT)',
    value: 'Asia/Ust-Nera',
    offset: 'UTC+10:00',
    abbreviation: 'VLAT',
  },
  {
    label: 'Vladivostok Time (VLAT)',
    value: 'Asia/Vladivostok',
    offset: 'UTC+10:00',
    abbreviation: 'VLAT',
  },
  {
    label: 'Yakutsk Time (YAKT)',
    value: 'Asia/Yakutsk',
    offset: 'UTC+09:00',
    abbreviation: 'YAKT',
  },
  {
    label: 'Myanmar Time (MMT)',
    value: 'Asia/Yangon',
    offset: 'UTC+06:30',
    abbreviation: 'MMT',
  },
  {
    label: 'Yekaterinburg Time (YEKT)',
    value: 'Asia/Yekaterinburg',
    offset: 'UTC+05:00',
    abbreviation: 'YEKT',
  },
  {
    label: 'Armenia Time (AMT)',
    value: 'Asia/Yerevan',
    offset: 'UTC+04:00',
    abbreviation: 'AMT',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Europe/Amsterdam',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Europe/Andorra',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Samara Time (SAMT)',
    value: 'Europe/Astrakhan',
    offset: 'UTC+04:00',
    abbreviation: 'SAMT',
  },
  {
    label: 'Eastern European Time (EET)',
    value: 'Europe/Athens',
    offset: 'UTC+02:00',
    abbreviation: 'EET',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Europe/Belgrade',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Europe/Berlin',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Europe/Bratislava',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Europe/Brussels',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Eastern European Time (EET)',
    value: 'Europe/Bucharest',
    offset: 'UTC+02:00',
    abbreviation: 'EET',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Europe/Budapest',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Eastern European Time (EET)',
    value: 'Europe/Chisinau',
    offset: 'UTC+02:00',
    abbreviation: 'EET',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Europe/Copenhagen',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Greenwich Mean Time (GMT)',
    value: 'Europe/Dublin',
    offset: 'UTC+00:00',
    abbreviation: 'GMT',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Europe/Gibraltar',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Eastern European Time (EET)',
    value: 'Europe/Helsinki',
    offset: 'UTC+02:00',
    abbreviation: 'EET',
  },
  {
    label: 'Turkey Time (TRT)',
    value: 'Europe/Istanbul',
    offset: 'UTC+03:00',
    abbreviation: 'TRT',
  },
  {
    label: 'Eastern European Time (EET)',
    value: 'Europe/Kaliningrad',
    offset: 'UTC+02:00',
    abbreviation: 'EET',
  },
  {
    label: 'Eastern European Time (EET)',
    value: 'Europe/Kiev',
    offset: 'UTC+02:00',
    abbreviation: 'EET',
  },
  {
    label: 'Moscow Time (MSK)',
    value: 'Europe/Kirov',
    offset: 'UTC+03:00',
    abbreviation: 'MSK',
  },
  {
    label: 'Western European Time (WET)',
    value: 'Europe/Lisbon',
    offset: 'UTC+00:00',
    abbreviation: 'WET',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Europe/Ljubljana',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Greenwich Mean Time (GMT)',
    value: 'Europe/London',
    offset: 'UTC+00:00',
    abbreviation: 'GMT',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Europe/Luxembourg',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Europe/Madrid',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Europe/Malta',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Moscow Time (MSK)',
    value: 'Europe/Minsk',
    offset: 'UTC+03:00',
    abbreviation: 'MSK',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Europe/Monaco',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Moscow Time (MSK)',
    value: 'Europe/Moscow',
    offset: 'UTC+03:00',
    abbreviation: 'MSK',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Europe/Oslo',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Europe/Paris',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Europe/Prague',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Eastern European Time (EET)',
    value: 'Europe/Riga',
    offset: 'UTC+02:00',
    abbreviation: 'EET',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Europe/Rome',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Samara Time (SAMT)',
    value: 'Europe/Samara',
    offset: 'UTC+04:00',
    abbreviation: 'SAMT',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Europe/San_Marino',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Samara Time (SAMT)',
    value: 'Europe/Saratov',
    offset: 'UTC+04:00',
    abbreviation: 'SAMT',
  },
  {
    label: 'Moscow Time (MSK)',
    value: 'Europe/Simferopol',
    offset: 'UTC+03:00',
    abbreviation: 'MSK',
  },
  {
    label: 'Eastern European Time (EET)',
    value: 'Europe/Sofia',
    offset: 'UTC+02:00',
    abbreviation: 'EET',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Europe/Stockholm',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Eastern European Time (EET)',
    value: 'Europe/Tallinn',
    offset: 'UTC+02:00',
    abbreviation: 'EET',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Europe/Tirane',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Samara Time (SAMT)',
    value: 'Europe/Ulyanovsk',
    offset: 'UTC+04:00',
    abbreviation: 'SAMT',
  },
  {
    label: 'Eastern European Time (EET)',
    value: 'Europe/Uzhgorod',
    offset: 'UTC+02:00',
    abbreviation: 'EET',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Europe/Vatican',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Europe/Vienna',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Eastern European Time (EET)',
    value: 'Europe/Vilnius',
    offset: 'UTC+02:00',
    abbreviation: 'EET',
  },
  {
    label: 'Moscow Time (MSK)',
    value: 'Europe/Volgograd',
    offset: 'UTC+03:00',
    abbreviation: 'MSK',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Europe/Warsaw',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Eastern European Time (EET)',
    value: 'Europe/Zaporozhye',
    offset: 'UTC+02:00',
    abbreviation: 'EET',
  },
  {
    label: 'Central European Time (CET)',
    value: 'Europe/Zurich',
    offset: 'UTC+01:00',
    abbreviation: 'CET',
  },
  {
    label: 'Indian Ocean Time (IOT)',
    value: 'Indian/Chagos',
    offset: 'UTC+06:00',
    abbreviation: 'IOT',
  },
  {
    label: 'Christmas Island Time (CXT)',
    value: 'Indian/Christmas',
    offset: 'UTC+07:00',
    abbreviation: 'CXT',
  },
  {
    label: 'Cocos Islands Time (CCT)',
    value: 'Indian/Cocos',
    offset: 'UTC+06:30',
    abbreviation: 'CCT',
  },
  {
    label: 'French Southern & Antarctic Time (TFT)',
    value: 'Indian/Kerguelen',
    offset: 'UTC+05:00',
    abbreviation: 'TFT',
  },
  {
    label: 'Maldives Time (MVT)',
    value: 'Indian/Maldives',
    offset: 'UTC+05:00',
    abbreviation: 'MVT',
  },
  {
    label: 'Mauritius Time (MUT)',
    value: 'Indian/Mauritius',
    offset: 'UTC+04:00',
    abbreviation: 'MUT',
  },
  {
    label: 'East Africa Time (EAT)',
    value: 'Indian/Mayotte',
    offset: 'UTC+03:00',
    abbreviation: 'EAT',
  },
  {
    label: 'Réunion Time (RET)',
    value: 'Indian/Reunion',
    offset: 'UTC+04:00',
    abbreviation: 'RET',
  },
  // Pacific timezone options with offsets and abbreviations
  {
    label: 'West Samoa Time (WST)',
    value: 'Pacific/Apia',
    offset: 'UTC+13:00',
    abbreviation: 'WST',
  },
  {
    label: 'New Zealand Standard Time (NZST)',
    value: 'Pacific/Auckland',
    offset: 'UTC+12:00',
    abbreviation: 'NZST',
  },
  {
    label: 'Bougainville Standard Time (BST)',
    value: 'Pacific/Bougainville',
    offset: 'UTC+11:00',
    abbreviation: 'BST',
  },
  {
    label: 'Chatham Standard Time (CHAST)',
    value: 'Pacific/Chatham',
    offset: 'UTC+12:45',
    abbreviation: 'CHAST',
  },
  {
    label: 'Chuuk Time (CHUT)',
    value: 'Pacific/Chuuk',
    offset: 'UTC+10:00',
    abbreviation: 'CHUT',
  },
  {
    label: 'Easter Island Time (EAST)',
    value: 'Pacific/Easter',
    offset: 'UTC-06:00',
    abbreviation: 'EAST',
  },
  {
    label: 'Vanuatu Time (VUT)',
    value: 'Pacific/Efate',
    offset: 'UTC+11:00',
    abbreviation: 'VUT',
  },
  {
    label: 'Tokelau Time (TKT)',
    value: 'Pacific/Fakaofo',
    offset: 'UTC+13:00',
    abbreviation: 'TKT',
  },
  {
    label: 'Fiji Time (FJT)',
    value: 'Pacific/Fiji',
    offset: 'UTC+12:00',
    abbreviation: 'FJT',
  },
  {
    label: 'Tuvalu Time (TVT)',
    value: 'Pacific/Funafuti',
    offset: 'UTC+12:00',
    abbreviation: 'TVT',
  },
  {
    label: 'Galapagos Time (GALT)',
    value: 'Pacific/Galapagos',
    offset: 'UTC-06:00',
    abbreviation: 'GALT',
  },
  {
    label: 'Gambier Time (GAMT)',
    value: 'Pacific/Gambier',
    offset: 'UTC-09:00',
    abbreviation: 'GAMT',
  },
  {
    label: 'Solomon Islands Time (SBT)',
    value: 'Pacific/Guadalcanal',
    offset: 'UTC+11:00',
    abbreviation: 'SBT',
  },
  {
    label: 'Chamorro Standard Time (ChST)',
    value: 'Pacific/Guam',
    offset: 'UTC+10:00',
    abbreviation: 'ChST',
  },
  {
    label: 'Hawaii Standard Time (HST)',
    value: 'Pacific/Honolulu',
    offset: 'UTC-10:00',
    abbreviation: 'HST',
  },
  {
    label: 'Hawaii Standard Time (HST)',
    value: 'Pacific/Johnston',
    offset: 'UTC-10:00',
    abbreviation: 'HST',
  },
  {
    label: 'Phoenix Island Time (PHOT)',
    value: 'Pacific/Kanton',
    offset: 'UTC+13:00',
    abbreviation: 'PHOT',
  },
  {
    label: 'Line Islands Time (LINT)',
    value: 'Pacific/Kiritimati',
    offset: 'UTC+14:00',
    abbreviation: 'LINT',
  },
  {
    label: 'Kosrae Time (KOST)',
    value: 'Pacific/Kosrae',
    offset: 'UTC+11:00',
    abbreviation: 'KOST',
  },
  {
    label: 'Marshall Islands Time (MHT)',
    value: 'Pacific/Kwajalein',
    offset: 'UTC+12:00',
    abbreviation: 'MHT',
  },
  {
    label: 'Marshall Islands Time (MHT)',
    value: 'Pacific/Majuro',
    offset: 'UTC+12:00',
    abbreviation: 'MHT',
  },
  {
    label: 'Marquesas Time (MART)',
    value: 'Pacific/Marquesas',
    offset: 'UTC-09:30',
    abbreviation: 'MART',
  },
  {
    label: 'Samoa Standard Time (SST)',
    value: 'Pacific/Midway',
    offset: 'UTC-11:00',
    abbreviation: 'SST',
  },
  {
    label: 'Nauru Time (NRT)',
    value: 'Pacific/Nauru',
    offset: 'UTC+12:00',
    abbreviation: 'NRT',
  },
  {
    label: 'Niue Time (NUT)',
    value: 'Pacific/Niue',
    offset: 'UTC-11:00',
    abbreviation: 'NUT',
  },
  {
    label: 'Norfolk Time (NFT)',
    value: 'Pacific/Norfolk',
    offset: 'UTC+11:00',
    abbreviation: 'NFT',
  },
  {
    label: 'New Caledonia Time (NCT)',
    value: 'Pacific/Noumea',
    offset: 'UTC+11:00',
    abbreviation: 'NCT',
  },
  {
    label: 'Samoa Standard Time (SST)',
    value: 'Pacific/Pago_Pago',
    offset: 'UTC-11:00',
    abbreviation: 'SST',
  },
  {
    label: 'Palau Time (PWT)',
    value: 'Pacific/Palau',
    offset: 'UTC+09:00',
    abbreviation: 'PWT',
  },
  {
    label: 'Pitcairn Time (PST)',
    value: 'Pacific/Pitcairn',
    offset: 'UTC-08:00',
    abbreviation: 'PST',
  },
  {
    label: 'Pohnpei Standard Time (PONT)',
    value: 'Pacific/Pohnpei',
    offset: 'UTC+11:00',
    abbreviation: 'PONT',
  },
  {
    label: 'Papua New Guinea Time (PGT)',
    value: 'Pacific/Port_Moresby',
    offset: 'UTC+10:00',
    abbreviation: 'PGT',
  },
  {
    label: 'Cook Island Time (CKT)',
    value: 'Pacific/Rarotonga',
    offset: 'UTC-10:00',
    abbreviation: 'CKT',
  },
  {
    label: 'Tahiti Time (TAHT)',
    value: 'Pacific/Tahiti',
    offset: 'UTC-10:00',
    abbreviation: 'TAHT',
  },
  {
    label: 'Gilbert Island Time (GILT)',
    value: 'Pacific/Tarawa',
    offset: 'UTC+12:00',
    abbreviation: 'GILT',
  },
  {
    label: 'Tonga Time (TOT)',
    value: 'Pacific/Tongatapu',
    offset: 'UTC+13:00',
    abbreviation: 'TOT',
  },
  {
    label: 'Wake Island Time (WAKT)',
    value: 'Pacific/Wake',
    offset: 'UTC+12:00',
    abbreviation: 'WAKT',
  },
  {
    label: 'Wallis & Futuna Time (WFT)',
    value: 'Pacific/Wallis',
    offset: 'UTC+12:00',
    abbreviation: 'WFT',
  },
];
